<template>
  <div class="header clearfix" :class="headerClasses">
    <div class="clearfix headerContent">
      <div class="top-logo">
        <div class="top-toHome" @click="toHome">
          <img
            v-if="showWhiteLogo"
            src="../assets/logo-w.png"
            alt="春阳台logo"
          />
          <img v-else src="../assets/logo-t.png" alt="春阳台logo" />
        </div>
      </div>

      <div class="top-right">
        <div class="lan">
          <div
            @click="changeLan(0)"
            class="changeLan"
            :class="{ lanActive: lan === 0 }"
          >
            中
          </div>
          <div
            @click="changeLan(1)"
            class="changeLan"
            :class="{ lanActive: lan === 1 }"
            v-show="shouldShowEnLan"
          >
            EN
          </div>
        </div>
      </div>

      <div class="top-culture" @click="toCulture">
        <img
          v-if="columnShowId == 7"
          src="../assets/shop_highllight.png"
          alt="文化商店"
        />
        <img
          v-else-if="showWhiteLogo"
          src="../assets/shop_white.png"
          alt="文化商店"
        />
        <img v-else src="../assets/shop_black.png" alt="文化商店" />
      </div>

      <nav class="top-nav">
        <ul class="ul clearfix" :class="{ english: isEnglish }">
          <li
            v-for="(item, index) in headerList"
            :key="item.id"
            @click="selColumn(index)"
          >
            <div :class="`selColumn${index}`" :style="getColumnStyle(item)">
              {{ isEnglish ? item.enName : item.name }}
            </div>
          </li>
        </ul>
      </nav>
    </div>

    <div class="sub-menu" v-if="submenu">
      <div class="sub-menu-content" :class="{ english: isEnglish }">
        <div class="sub-ul" v-for="item in filteredSubList" :key="item.id">
          <div class="sub-ul-show">
            <a
              v-if="item.toId && columnShowId == 1"
              @click="goToSmooth(item.id)"
            >
              {{ isEnglish ? item.enName : item.name }}
            </a>
            <router-link
              v-else
              :to="{ name: item.requestTo, query: { columnId: item.id } }"
            >
              {{ isEnglish ? item.enName : item.name }}
            </router-link>
          </div>
        </div>

        <div class="close-btn" @click="closeMenu">
          <img v-if="showWhiteLogo" src="../assets/close-w.png" alt="关闭" />
          <img v-else src="../assets/close.png" alt="关闭" />
        </div>
      </div>
    </div>

    <div id="overlay" class="overlay" @click.stop="closeMenu"></div>
  </div>
</template>

<script>
import { showToast } from "../utils/js/toast.js";

export default {
  name: "Header",
  props: {
    index: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isIndex: this.index,
      headerList: [
        // 关于春阳台
        {
          id: 1,
          name: "关于春阳台",
          enName: "About CYT",
          requestTo: "aboutCY",
          subList: [
            {
              id: 1,
              name: "春阳台概况",
              enName: "About CYT",
              requestTo: "aboutCY",
              toId: false,
            },
            {
              id: 11,
              name: "特色空间",
              enName: "Space",
              requestTo: "aboutCY",
              toId: true,
            },
            {
              id: 12,
              name: "关于建筑",
              enName: "Architecture",
              requestTo: "aboutCY",
              toId: true,
            },
          ],
        },
        // 展览
        {
          id: 2,
          name: "展览",
          enName: "Exhibitions",
          requestTo: "exhibition",
          subList: [
            {
              id: 2,
              name: "正在展出",
              enName: "On Now",
              requestTo: "exhibition",
              toId: false,
            },
            {
              id: 21,
              name: "过往展出",
              enName: "Past",
              requestTo: "previousExhibitions",
              toId: false,
            },
          ],
        },
        // 活动
        {
          id: 3,
          name: "活动",
          enName: "Events",
          requestTo: "activityList",
          subList: [
            {
              id: 3,
              name: "展览项目",
              enName: "Exhibition Related",
              requestTo: "activityList",
              toId: false,
            },
            {
              id: 31,
              name: "学术活动",
              enName: "Academic",
              requestTo: "scienceActive",
              toId: false,
            },
            {
              id: 32,
              name: "研学与公教活动",
              enName: "Research and Education",
              requestTo: "researchEducation",
              toId: false,
            },
            {
              id: 33,
              name: "公共活动",
              enName: "Public",
              requestTo: "publicActivities",
              toId: false,
            },
            {
              id: 34,
              name: "品牌活动",
              enName: "Brand",
              requestTo: "brandActivity",
              toId: false,
            },
          ],
        },
        // 研究
        {
          id: 4,
          name: "研究",
          enName: "Research",
          requestTo: "study",
          subList: [
            {
              id: 4,
              name: "春阳典藏",
              enName: "Research",
              requestTo: "study",
              toId: false,
            },
          ],
        },
        // 塱头
        {
          id: 5,
          name: "塱头",
          enName: "About Langtou",
          requestTo: "rural",
          subList: [
            {
              id: 51,
              name: "项目大事记",
              enName: "Memorabilia",
              requestTo: "Memorabilia",
              toId: false,
            },
            {
              id: 5,
              name: "古村概况",
              enName: "Overview",
              requestTo: "rural",
              toId: false,
            },
            {
              id: 52,
              name: "古村展览",
              enName: "Exhibitions",
              requestTo: "currentExhibition",
              toId: false,
            },
            {
              id: 53,
              name: "住宿体验",
              enName: "Guesthouse",
              requestTo: "lodgingExperience",
              toId: false,
            },
          ],
        },
        // 参观指南
        {
          id: 6,
          name: "参观指南",
          enName: "Tips",
          requestTo: "visitor",
          subList: [
            {
              id: 6,
              name: "参观指南",
              enName: "Tips",
              requestTo: "visitor",
              toId: false,
            },
          ],
        },
      ],
      lan: this.$store.state.isEn,
      isLoaded: this.$store.state.isLoaded,
      columnId: "",
      nowScrollToTop: 0,
      submenu: false,
      columnIndex: 0,
      columnShowId: 0,
      showScroll: false,
    };
  },

  computed: {
    isEnglish() {
      return this.lan === 1;
    },

    showWhiteLogo() {
      return this.nowScrollToTop < 20 && !this.showScroll;
    },

    shouldShowEnLan() {
      return this.columnShowId !== 51;
    },

    filteredSubList() {
      if (!this.headerList[this.columnIndex]) return [];

      // 英文时隐藏 id=51 的项，中文时全部显示
      return this.isEnglish
        ? this.headerList[this.columnIndex].subList.filter(
            (item) => item.id !== 51
          )
        : this.headerList[this.columnIndex].subList;
    },

    headerClasses() {
      return {
        scroll: this.nowScrollToTop >= 19 || this.showScroll,
        submenuChange:
          this.submenu && this.nowScrollToTop <= 20 && !this.showScroll,
      };
    },
  },

  watch: {
    "$store.state.isEn"(newVal) {
      this.lan = newVal;
    },

    "$store.state.isLoaded"(newVal) {
      this.isLoaded = newVal;
    },

    submenu: {
      handler(newValue) {
        this.toggleOverlay();
      },
      deep: true,
    },
  },

  created() {
    this.initLanguage();
  },

  mounted() {
    this.initColumnId();
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    initLanguage() {
      let lan;
      const urlLan = this.$route.query.lan;

      // 语言映射表
      const langMap = { EN: 1, CN: 0 };

      if (urlLan !== undefined) {
        const normalized = String(urlLan).toUpperCase();
        lan = langMap.hasOwnProperty(normalized)
          ? langMap[normalized]
          : parseInt(normalized, 10) || 0;
      } else {
        try {
          lan = JSON.parse(localStorage.getItem("lan")) || 0;
        } catch (e) {
          console.error("本地语言解析失败:", e);
          lan = 0;
        }
      }

      this.lan = lan;
      this.$store.commit("changeLan1", this.lan);
    },

    initColumnId() {
      let columnId = this.$route.query.columnId;
      if (columnId === undefined) {
        columnId = 38;
      }

      // 控制页面顶部是否展示为滚动效果
      const scrollColumns = [
        1, 11, 13, 12, 2, 23, 21, 3, 31, 32, 33, 34, 35, 4, 41, 5, 51, 52, 53,
        55, 6, 7,
      ];

      this.showScroll = scrollColumns.includes(Number(columnId));

      // 控制头部页面类型选择
      const columnMap = {
        1: [1, 11, 12, 13],
        2: [2, 23, 21],
        3: [3, 31, 32, 33, 34, 35],
        4: [4, 41],
        5: [5, 52, 53, 55],
        51: [51],
        6: [6],
        7: [7],
      };

      for (const [showId, ids] of Object.entries(columnMap)) {
        if (ids.includes(Number(columnId))) {
          this.columnShowId = Number(showId);
          break;
        }
      }

      // 延迟执行滚动操作，确保页面元素已加载
      if ([11, 12].includes(Number(columnId))) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (columnId == 11) {
              const keySpaceElement = document.getElementById("keySpace");
              keySpaceElement?.scrollIntoView({ behavior: "smooth" });
            }
            if (columnId == 12) {
              const architectureElement =
                document.getElementById("architecture");
              architectureElement?.scrollIntoView({ behavior: "smooth" });
            }
          }, 100);
        });
      }

      this.columnId = columnId;
    },

    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.nowScrollToTop = Math.floor(scrollTop);
    },

    getColumnStyle(item) {
      const isActive =
        item.id == this.columnShowId ||
        (item.id == 5 && this.columnShowId == 51);

      return {
        color: isActive ? "#CA9D76" : "",
        fontWeight: isActive ? "bold" : "Regular",
      };
    },

    changeLan(lang) {
      if (this.lan === lang) return;

      this.$store.commit("changeLan");
      this.lan = this.$store.state.isEn;
      localStorage.setItem("lan", this.lan);

      // 在详情页切换语言时返回上一级页面
      if (this.$route.matched[1]?.meta.title === "detail") {
        let id;
        try {
          id = JSON.parse(localStorage.getItem("columnId"));
        } catch (e) {
          console.log(e);
        }

        this.$router.push({
          path: this.$route.matched[0].path,
          query: { columnId: id },
        });
      }
    },

    toggleOverlay() {
      const overlay = document.getElementById("overlay");
      if (overlay) {
        overlay.style.display = this.submenu ? "block" : "none";
      }
    },

    selColumn(index) {
      const item = this.headerList[index];

      if (item.subList.length === 1) {
        this.$router.push({
          name: item.subList[0].requestTo,
          query: { columnId: item.id },
        });
        return;
      }

      this.submenu = this.columnIndex === index ? !this.submenu : true;

      if (this.submenu) {
        this.$nextTick(() => {
          this.toggleOverlay();
          const selector = `.selColumn${index}`;
          const box = document.querySelector(selector);
          const subContent = document.querySelector(".sub-menu-content");

          if (box && subContent) {
            const rect = box.getBoundingClientRect();
            box.style.color = "#ca9d76";
            subContent.style.left = `${rect.left - 15}px`;
          }
        });
      }

      this.columnIndex = index;
    },

    closeMenu() {
      this.submenu = false;
    },

    toCulture() {
      this.$router.push({
        name: "culturalCreative",
        query: { columnId: 7 },
      });
    },

    toHome() {
      window.scrollTo(0, 0);
      this.$router.push({
        name: "Home",
        query: { columnId: 38 },
      });
    },

    goToSmooth(id) {
      this.submenu = false;

      const elementMap = {
        11: "keySpace",
        12: "architecture",
      };

      const elementId = elementMap[id];
      if (elementId) {
        const element = document.getElementById(elementId);
        element?.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>
<style scoped>
.header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  min-width: 320px;
  z-index: 1000;
}
.headerContent {
  width: 92%;
  margin: 0 auto;
}
.header .top-logo {
  float: left;
  line-height: 140px;
  margin-left: calc(10vw - 15px);
  max-width: 280px;
}
.header .top-logo img {
  width: 267px;
  height: 48px;
}
.header .top-right {
  float: right;
  line-height: 140px;
  transition: all 0.3s;
}
.header .top-right > div {
  float: right;
  margin-left: 18px;
}
.header .top-nav {
  float: right;
  z-index: 100;
}
.header .top-culture {
  position: relative;
  float: right;
  z-index: 100;
  width: 14px;
  height: 14px;
  line-height: 135px;
  transition: all 0.3s;
  margin-left: 30px;
  cursor: pointer;
}
.header .top-culture::before {
  content: "";
  position: absolute;
  right: -12px;
  top: 100%;
  transform: translateY(330%);
  width: 1px;
  height: 15px;
  transition: all 0.3s;
  background-color: rgba(255, 255, 255, 0.3);
}
.header .top-nav.show {
  right: 0;
}

.header ul {
  position: relative;
}
.header ul::before {
  content: "";
  position: absolute;
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 15px;
  background-color: rgba(255, 255, 255, 0.3);
}
.header ul li {
  float: left;
  line-height: 140px;
  padding: 0 10px;
  transition: all 0.3s;
}
.header ul li:first-child {
  padding-left: 0;
}
.header ul li:last-child {
  padding-right: 0;
}
.header ul li div {
  width: 100%;
  height: 100%;
  display: block;
  font-size: 15px;
  font-weight: Regular;
  color: #fff;
  position: relative;
  cursor: pointer;
}

.header .english li {
  padding: 0 13px;
}
.header ul li div::before {
  content: "";
  background: url(../assets/diandian_highllight.png) no-repeat center;
  background-size: contain;
  position: absolute;
  bottom: 47px;
  left: 50%;
  width: 0;
  height: 4px;
  transform: translateX(-50%);
}
.header ul li:hover div::before,
.header ul li.aon div::before {
  width: 20px;
  transition: all 0.3s;
}

.header .lan {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 80px;
  font-family: SourceHanSansCN-Bold;
  font-size: 15px;
  color: #fff;
  text-align: left;
  margin-right: calc(10vw - 60px);
}
.lanActive {
  color: #ca9d76;
  font-weight: normal;
}
.changeLan {
  width: 30px;
  height: 100%;
  text-align: center;
  font-weight: normal;
}
.sub-menu {
  position: relative;
  height: 410px;
  color: #fff;
  animation: fadeIn 0.5s; /* 淡入时间为1秒 */
  background-color: #000;
  z-index: 1;
}
.sub-menu-content {
  position: absolute;
  left: -50%;
}
.sub-ul {
  transition: all 0.3s;
}
.sub-ul .sub-ul-show {
  font-family: SourceHanSansCN-Medium;
  font-size: 22px;
  letter-spacing: 0;
  font-weight: 500;
  color: #fff;
  width: 100%;
  margin-top: 25px;
  margin-left: 15px;
}
.header .sub-ul-show a {
  position: relative;
  display: inline-block;
  text-decoration: none;
  color: #fff;
  height: 35px;
  padding-bottom: 2px;
  overflow: hidden;
  background-image: linear-gradient(
    to right,
    #2c2c2c 100%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: 0% 100%;
  background-repeat: no-repeat;
  background-size: 0 2px;
  transition: background-size 0.3s;
}

.header .sub-ul-show a:hover,
.header .sub-ul.aon .sub-ul-show a {
  transition: none;
  animation: underlineFromRight 0.3s forwards;
}

@keyframes underlineFromRight {
  0% {
    background-size: 0 2px; /* 起始时没有下划线 */
  }
  100% {
    background-size: 100% 2px; /* 结束时下划线扩展到整个元素宽度 */
  }
}
@media (max-width: 1670px) {
  .header .lan {
    margin-right: 0px;
  }
  .header .top-logo {
    margin-left: calc(6vw - 40px);
  }
}
@media (max-width: 1440px) {
  .header {
    max-width: 99.9%;
  }
  .headerContent {
    width: 100%;
  }
  .header .top-nav {
    float: right;
    z-index: 110;
  }
  .header .top-logo {
    float: left;
    margin-left: calc(6vw - 9px);
    max-width: 280px;
  }

  .header ul li div {
    font-size: 15px;
  }
  .header .lan {
    margin-right: calc(6vw - 35px);
  }
}

/* 屏幕滚动后的处理 */
.scroll {
  height: 94px;
  background-color: #fff; /* 替换为你需要的颜色 */
  border-bottom: 1px solid #f2f2f2;
  z-index: 1000;
}
.scroll .auto {
  height: 94px;
}
.scroll ul li div {
  color: #000;
}
.scroll .top-logo,
.scroll .top-right,
.scroll ul li {
  line-height: 94px;
}
.scroll .sub-menu {
  height: 410px;
  color: #000;
  background-color: #fff;
  z-index: 1;
}
.scroll .sub-ul a {
  color: #000;
}
.scroll .top-culture {
  line-height: 90px;
}
.submenuChange .top-culture {
  line-height: 90px;
}
.submenuChange .top-culture::before {
  transform: translateY(170%);
  background-color: rgba(0, 0, 0, 0.3);
}
.scroll .top-culture::before {
  transform: translateY(170%);
  background-color: rgba(0, 0, 0, 0.3);
}
.scroll ul::before {
  background-color: rgba(0, 0, 0, 0.3);
}
.submenuChange ul::before {
  background-color: rgba(0, 0, 0, 0.3);
}
.submenuChange {
  background-color: #000;
  height: 94px;
  color: #fff;
}
.submenuChange .top-logo,
.submenuChange .top-right,
.submenuChange ul li {
  line-height: 94px;
}
.submenuChange .sub-ul:hover a::before,
.submenuChange .sub-ul.aon a::before {
  width: 60%;
  background-color: #fff;
  transition: all 0.3s;
}
.submenuChange ul li div::before {
  bottom: 27px;
}
.sub-ul-show {
  cursor: pointer;
}
.submenuChange .sub-ul-show a {
  position: relative;
  display: inline-block;
  text-decoration: none;
  color: #fff;
  height: 35px;
  padding-bottom: 2px;
  overflow: hidden;
  background-image: linear-gradient(to left, #ffffff 0%, #ffffff 100%);
  background-position: 0% 100%;
  background-repeat: no-repeat;
  background-size: 0 2px;
  transition: background-size 0.3s;
}

.submenuChange .sub-ul-show a:hover,
.submenuChange .sub-ul.aon .sub-ul-show a {
  transition: none;
  animation: underlineFromRight 0.3s forwards;
}
.scroll ul li div::before {
  bottom: 27px;
}
.scroll .lan {
  color: #000;
}
.close-btn {
  position: absolute;
  bottom: -50px;
  width: 50px;
  height: 30px;
  margin-left: 5px;
  text-align: center;
  cursor: pointer;
}
.close-btn img {
  width: 24px;
  height: 24px;
}
.overlay {
  position: fixed;
  top: 120px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 设置背景颜色和透明度 */
  display: none; /* 默认是隐藏的 */
  z-index: 0;
}
.top-toHome {
  cursor: pointer;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
